module.exports = __webpack_public_path__ + "img/burger-arrow.63f5792d.svg";